<template>
  <svg class="xds:icon" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.99666 5.50677V6.63177M3.23914 6.66327C3.23914 7.07748 3.59667 7.36832 4.01088 7.36832C4.42509 7.36832 4.78262 7.07748 4.78262 6.66327M4.24678 5.38159C4.24678 5.51966 4.13485 5.63159 3.99678 5.63159C3.85871 5.63159 3.74678 5.51966 3.74678 5.38159C3.74678 5.24352 3.85871 5.13159 3.99678 5.13159C4.13485 5.13159 4.24678 5.24352 4.24678 5.38159Z"
      stroke="currentColor"
      stroke-width="0.4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.10134 6.46336C3.10134 6.57382 3.19088 6.66323 3.30134 6.66323H4.70024C4.8107 6.66323 4.90024 6.57376 4.90024 6.46331C4.90024 6.34634 4.90024 6.18039 4.90024 5.97168C4.90024 5.53026 4.90024 5.14878 5.32529 4.64878C5.78103 4.14439 5.87571 4.02232 5.87571 3.27232C5.83145 2.43076 5.20994 1.56323 3.99688 1.56323C2.78382 1.56323 2.11804 2.52083 2.11804 3.27232C2.11804 4.12653 2.45634 4.32589 2.6668 4.64878C2.87726 4.97168 3.10134 5.41852 3.10134 5.97168C3.10134 6.19948 3.10134 6.35694 3.10134 6.46336Z"
      stroke="currentColor"
      stroke-width="0.4"
    />
    <path
      d="M3.99656 0.963429L3.99669 0.800049M5.95156 1.90514L6.07861 1.80242M6.43399 4.01947L6.59315 4.05634M1.55925 4.01959L1.40002 4.05622M2.04157 1.90521L1.91468 1.8023"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linecap="round"
    />
  </svg>
</template>
